import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { OptionCard } from 'components/OptionCard'
import {
  TERMS_LINKS_GROUP_VARIANT,
  TermsLinksGroup,
} from 'components/TermsLinksGroup'

import { useDelayedContinue } from 'hooks/useDelayedContinue'
import { useExperimentalFeatures } from 'hooks/useExperimentalFeatures'
import { useNextStep } from 'hooks/useNextStep'

import { TPageProps } from 'models/common.model'

import { CustomPageId } from 'page-constants'
import { Color, Language, OptionType } from 'root-constants'

import { StyledSelectGenderParent as S } from './SelectGenderParent.styles'
import {
  PARENT_GENDER_OPTIONS,
  PARENT_GENDER_QUIZ_V3_OPTIONS,
} from './constants'

export const SelectGenderParent: React.FC<TPageProps> = ({
  pageId,
  nextPagePath,
  isFirstPage,
}) => {
  const { t } = useTranslation()
  const { isAyah115ParentingQuizTestGroup } = useExperimentalFeatures()
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const [answer, setAnswer] = useState<string>('')

  const titleKey = isAyah115ParentingQuizTestGroup
    ? 'onboarding.selectGenderParent.quranicParentingResetTitle'
    : 'onboarding.selectGenderParent.title'
  const options = isAyah115ParentingQuizTestGroup
    ? PARENT_GENDER_QUIZ_V3_OPTIONS
    : PARENT_GENDER_OPTIONS

  const handleContinue = useNextStep({
    pageId: CustomPageId.GENDER,
    question: t(titleKey, {
      lng: Language.EN,
    }),
    nextPagePath,
    isFirstPage,
  })

  const handleAnswerChange = (value: string) => {
    handleChange(value, handleContinue)
    setIsAnswersDisabled(true)
    setAnswer(value)
  }

  return (
    <S.Container>
      <S.Title>{t(titleKey)}</S.Title>
      <S.QuizLabel>{t('onboarding.selectGenderParent.quizLabel')}</S.QuizLabel>

      <S.CardsContainer>
        {options.map(({ value, text, imageUrl }) => (
          <OptionCard
            key={value}
            imageUrl={imageUrl}
            value={value}
            label={t(text)}
            checked={answer === value}
            disabled={isAnswersDisabled}
            $backgroundColor={Color.SKY_DARK}
            $minHeight="268px"
            $isCompactLabel
            $renderImageAsImg
            name={pageId}
            type={OptionType.RADIO}
            onChange={handleAnswerChange}
          />
        ))}
      </S.CardsContainer>

      <S.Terms>
        <TermsLinksGroup
          titleKey="commonComponents.termsGenderTitle"
          variant={TERMS_LINKS_GROUP_VARIANT.DARK}
        />

        <S.TermsNote>{t('commonComponents.termsNote')}</S.TermsNote>
      </S.Terms>
    </S.Container>
  )
}
